import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { OCProvider } from './OCContext';
import { ClientAdminProductsView } from './async_views/client_admin_products_view';
import { ClientAdminUsersView } from './async_views/client_admin_users_view';
import CustomerButton from './components/CustomerButton';
import { ProductStyleCardPanel } from './components/domains/product/product_style_card_panel';
import { NotificationList } from './components/notifications/notification_list';
import { buildActionParserService } from './domain/injector';
import { Toaster } from 'react-hot-toast';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/outline';

declare global {
  interface Window {
    rendivo: any;
  }
}

let rootCustomerManager: ReactDOM.Root | null = null;

let rootNotifications: ReactDOM.Root | null = null;

let content: ReactDOM.Root | null = null; // Create a client

const queryClient = new QueryClient();

const CustomerManager = () => (
  <OCProvider>
    <CustomerButton />
  </OCProvider>
);

if (!Object.prototype.hasOwnProperty.call(window, 'rendivo')) {
  window.rendivo = {};
}

window.rendivo.postUserLoginActions = [];

window.rendivo.addPostUserLoginAction = (action: () => void) => {
  window.rendivo.postUserLoginActions.push(action);
};

window.rendivo.processPostUserLoginActions = () => {
  const actions: Array<() => void> = window?.rendivo?.postUserLoginActions;
  const poped = actions?.pop();
  if (poped) {
    poped();
    window.rendivo.processPostUserLoginActions();
  }
};

window.rendivo.loadComponents = () => {
  // Load Customer Manager component.
  rootCustomerManager = ReactDOM.createRoot(
    document.getElementById('ren_customer_manager') as HTMLElement
  );
  rootCustomerManager.render(<CustomerManager />);

  // Load Notifications component.
  rootNotifications = ReactDOM.createRoot(
    document.getElementById('ren_notifications') as HTMLElement
  );
  rootNotifications.render(<NotificationList />);
};

window.rendivo.unloadComponents = () => {
  // Unload Customer Manager component.
  if (rootCustomerManager) {
    rootCustomerManager.unmount();
    rootCustomerManager = null;
  }

  // Unload Notifications component
  if (rootNotifications) {
    rootNotifications.unmount();
    rootNotifications = null;
  }
};

window.rendivo.loadClientAdminUsersView = (rootUrl: string) => {
  content = ReactDOM.createRoot(
    document.querySelector('[data-id="content_panel"]') as HTMLElement
  );
  content.render(<ClientAdminUsersView />); // <Loadable url={url} />, boot);
};

window.rendivo.unloadClientAdminView = () => {
  if (content) {
    content.unmount();
    content = null;
  }
};

window.rendivo.loadClientAdminProductsView = (rootUrl: string) => {
  content = ReactDOM.createRoot(
    document.querySelector('[data-id="content_panel"]') as HTMLElement
  );
  content.render(
    <QueryClientProvider client={queryClient}>
      <ClientAdminProductsView />
      <Toaster
        toastOptions={{
          position: 'top-right',
          success: {
            icon: <CheckCircleIcon className="h-6 w-6" />,
          },
          error: {
            icon: <XCircleIcon className="h-6 w-6" />,
          },
        }}
      />
    </QueryClientProvider>
  );
};

window.rendivo.unloadClientAdminView = () => {
  if (content) {
    content.unmount();
    content = null;
  }
};

type ShowHouseStyleSelectorProps = {
  product_id: string; // The parent Product ID.
  style_product_id: string; //
  onSelect: (styleProductId: string) => void;
};

/**
 *
 */
window.rendivo.showHouseStyleSelector = ({
  product_id,
  style_product_id,
  onSelect,
}: ShowHouseStyleSelectorProps) => {
  const boot = ReactDOM.createRoot(
    document.getElementById('ren_client') as HTMLElement
  );

  const closePopup = () => boot.unmount();

  const closePopupAndRemovePopStateEventListener = () => {
    window.removeEventListener(
      'popstate',
      closePopupAndRemovePopStateEventListener
    );
    closePopup();
  };

  window.addEventListener('popstate', closePopupAndRemovePopStateEventListener);

  const onSelectWrapper = (styleProductId: string) => {
    closePopup();
    onSelect(styleProductId);
  };
  boot.render(
    <QueryClientProvider client={queryClient}>
      <ProductStyleCardPanel
        productId={product_id}
        styleProductId={style_product_id}
        onSelect={onSelectWrapper}
        onClose={closePopup}
      />
    </QueryClientProvider>
  );
};

window.rendivo.actions = {
  parse: buildActionParserService().parse,
};

window.rendivo.loadTest = () => {
  window.rendivo.loadClientAdminProductsView();
  // document.addEventListener(WINDOW_CLOSE_EVENT_TYPE, (e: CustomEvent) => {
  // });

  // const boot = ReactDOM.createRoot(
  //   document.getElementById('ren_notifications') as HTMLElement
  // );

  // // boot.render(<ClientAdminProductsView />);
  // boot.render(
  //   <>
  //     <button
  //       onClick={() => {
  //         // const ev = new CustomEvent<NotificationListRefreshEventData>(
  //         //   TYPE,
  //         //   {}
  //         // );

  //         const ev = new CustomEvent<WindowCloseEventData>(TYPE, {
  //           detail: {
  //             type: WindowCloseEventDataType.NAV_TOP,
  //             window_id: 'foo',
  //           },
  //         });
  //         document.dispatchEvent(ev);
  //       }}
  //     >
  //       Bang
  //     </button>
  //     <NotificationList />
  //   </>
  // );
};
